'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initializeSentry = initializeSentry;
exports.initializeSentryUserContext = initializeSentryUserContext;

var _ravenJs = require('raven-js');

var _ravenJs2 = _interopRequireDefault(_ravenJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapConsoleErrorForSentry(raven) {
    var originalConsoleError = window.console.error; // eslint-disable-line no-console
    window.console.error = function consoleErrorWrapper(errString) {
        raven.captureException(errString);
        originalConsoleError(errString);
    };
}

function internalInitializeSentry(sentryDSN, releaseVersion) {
    var raven = _ravenJs2.default.config(sentryDSN, {
        release: releaseVersion
    }).install();
    window.Raven = raven; // expose for sentry-react-transform

    return raven;
}

function initializeSentry(application) {
    var settings = application.settings;

    var releaseVersion = settings.get('gitVersion', 'unknownVersion');
    application.logger.info('run application version \'' + releaseVersion + '\'');

    try {
        var sentryDSN = settings.get('sentryDSN');

        application.raven = internalInitializeSentry(sentryDSN, releaseVersion);
        // console errors will be sent to sentry only after raven was initialized
        wrapConsoleErrorForSentry(application.raven);
    } catch (e) {
        application.logger.warn('can\'t read sentry security token. skip initialization. ' + e.message);
    }
}

function initializeSentryUserContext(application) {
    if (!application.raven) {
        return;
    }

    try {
        var userInfo = application.authorization.getUserInfo();
        application.raven.setUserContext({
            id: userInfo.user_id
        });
    } catch (e) {
        application.logger.warn('Skip userContext initialization for sentry. ' + e.message);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/sentryIntegration.js
// module id = 1330
// module chunks = 118